<template>
  <div class="fill-product-info-root">
    <!-- 商品下架原因 -->
    <div class="sold-out" v-if="formIn.platformCheckReason">
      <div class="sold-out-title">平台下架原因</div>
      <div class="sold-out-content">
        {{ formIn.platformCheckReason }}
      </div>
    </div>
    <div class="product-info">
      <div class="pic-frame">
        <img
          :src="goodsDetail && goodsDetail.compGoodsBaseVo ? goodsDetail.compGoodsBaseVo.image : ''"
          class="pic"
        />
      </div>
      <div class="txt-content">
        <div class="big-title">
          {{ goodsDetail ? goodsDetail.compGoodsBaseVo.name : "" }}
        </div>
        <div class="desp">
          {{ goodsDetail ? goodsDetail.compGoodsBaseVo.specification : "" }}
        </div>
        <div class="desp">
          {{ goodsDetail ? goodsDetail.compGoodsBaseVo.factory : "" }}
        </div>
        <div class="desp">
          {{ goodsDetail ? goodsDetail.compGoodsBaseVo.approvalNumber : "" }}
        </div>
      </div>
      <div class="flag">{{ formIn.activityType | selectTypeDetail }}</div>
    </div>
    <el-form :disabled="isDisabled">
      <div class="big-content">
        <div class="harf-block">
          <div class="big-block">
            <div class="title-block">
              <span class="text">价格/库存</span>
            </div>
            <div class="form-content">
              <div class="row">
                <div class="tip">ERP编码</div>
                <div class="value input">
                  <el-input
                    size="small"
                    placeholder="请输入"
                    v-model="formIn.medicineCode"
                  />
                </div>
              </div>

              <div class="row" v-if="formIn.activityType ==4" >
                  <div class="tip"><span class="weight" v-if=" formIn.chargeFlag || ( goodsId != xiaocaihuId) ">*</span>  价格(元)</div> 
                  <div class="value input">
                      <el-input size="small" placeholder="请输入" v-model="formIn.salePrice"  v-positive-five-limit />
                  </div> 
              </div>

              <div class="row">
                <div class="tip"><span class="weight">*</span>总库存</div>
                <div class="value input">
                  <el-input
                    size="small"
                    placeholder="请输入"
                    v-model="formIn.goodsSkuInventory"
                    :disabled="formIn.beSynStock"
                  />
                </div>
                <div class="value fill">
                  <el-checkbox
                    v-model="formIn.beSynStock"
                    :disabled="!formIn.medicineCode"
                    @change="stockChange"
                    >自动同步库存</el-checkbox
                  >
                </div>
              </div>
        
                  <!-- businessType === 2 消肿止痛贴 -->
              <div v-if="formIn.businessType === 2">
                <div class="row">
                  <div class="tip">价格</div>
                  <div class="value input">
                    <el-input size="small" placeholder="请输入" v-model="formIn.xzztPrice"  v-positive-five-limit
                      :disabled="true" />
                  </div>
                </div>
              </div>
              <div class="row"  v-if="formIn.activityType == 1 || formIn.activityType == 2">
                <div class="tip"><span class="weight">*</span>价格</div>
                <div class="value input">
                  <el-input
                    size="small"
                    placeholder="请输入"
                    v-model="formIn.salePrice"
                    :disabled="formIn.beSynPrice"
                  />
                </div>
                <div class="value fill">
                  <el-checkbox
                    v-model="formIn.beSynPrice"
                    :disabled="!formIn.medicineCode"
                    @change="erpPriceChange"
                    >自动同步价格</el-checkbox
                  >
                </div>
              </div>

              <div   v-if="formIn.activityType == 1"> 
                <div class="row">
                  <div class="tip">市场价</div>
                  <div class="value input">
                    <el-input
                      size="small"
                      placeholder="请输入"
                      v-model="formIn.marketPrice"
                    />
                  </div>
                </div>
                <div class="row" >
                  <div class="tip">建议零售价</div>
                  <div class="value input">
                    <el-input
                      size="small"
                      placeholder="请输入"
                      v-model="formIn.purchasePrice"
                    />
                  </div>
                </div>
              </div>

              <!-- <div class="row" v-if="formIn.activityType == 3">
                <div class="tip">原价</div>
                <div class="value input">
                  <el-input
                    size="small"
                    placeholder="请输入"
                    v-model="formIn.salePrice"
                    :disabled="formIn.beSynPrice"
                  />
                </div>
              </div> -->

              <div class="row" v-if="formIn.activityType == 3 || formIn.activityType == 2">
                <div class="tip">原价</div>
                <div class="value input">
                  <el-input size="small" placeholder="请输入" v-model="formIn.originalPrice" :disabled="formIn.beSynPrice"  v-positive-five-limit /> 
                </div>
              </div>

              <div class="row" v-if="formIn.activityType == 3">
                <div class="tip"><span class="weight">*</span>价格</div>
                <div class="value input">
                  <el-input
                    size="small"
                    placeholder="请输入"
                    v-model="formIn.groupBuyPrice"
                  />
                </div>
              </div> 

              <div class="row" v-if="formIn.activityType == 2" >
                <div class="tip"> <span class="weight">*</span> 活动库存</div>
                <div class="value input">
                  <el-input size="small" placeholder="请输入" v-model="formIn.activeInventory" maxlength="8" v-positive-integer/>
                </div>
                <div class="value fill">
                  <el-checkbox v-model="formIn.showInventoryFlag" :true-label="1" :false-label="0">是否展示给客户剩余库存量</el-checkbox>
                </div>
              </div> 
              
              <div class="row">
                <div class="tip"><span class="weight">*</span>单位</div>
                <div class="value input">
                  <el-select
                    v-model="formIn.goodsSkuUnit"
                    placeholder="请选择"
                    size="small"
                  >
                    <el-option
                      v-for="item in unitList"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="row" v-if="formIn.activityType == 1 || formIn.activityType == 2 || formIn.activityType == 3 ">
                <div class="tip"  ><span class="weight">*</span> {{formIn.activityType == 3 ? '包邮量' :'起批量' }}</div> 
                <div class="value input">
                  <el-input
                    size="small"
                    placeholder="请输入"
                    v-model="formIn.startWholesale"
                  />
                </div>
                <div class="value fill" v-if="formIn.activityType == 1 ">
                  <el-checkbox v-model="formIn.useTimes">倍数购买</el-checkbox>
                </div>
              </div> 

              <div class="row">
                <div class="tip"><span class="weight">*</span>有效期至</div>
                <div class="value input">
                  <el-date-picker
                    v-model="formIn.expireTime"
                    type="datetime"
                    placeholder="请选择"
                    size="small"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </div>
                <!-- <div class="value fill">
                  <el-checkbox
                    v-model="formIn.beSynDate"
                    :disabled="!formIn.medicineCode"
                    @change="dateChangeSyn"
                    >自动同步有效期和生产日期</el-checkbox
                  >
                </div> -->
              </div>
              <div class="row">
                <div class="tip"><span class="weight">*</span>生产日期</div>
                <div class="value input">
                  <el-date-picker
                    v-model="formIn.producedTime"
                    type="datetime"
                    placeholder="请选择"
                    size="small"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </div>
              </div>
              
              <div v-if="formIn.activityType == 2 || formIn.activityType == 3  ">  
                <div class="row">
                  <div class="tip">购买倍数</div>
                  <div class="value input">
                    <el-input
                      size="small"
                      v-positive-integer
                      placeholder="请输入"
                      v-model="formIn.multiple"
                    />
                  </div>
                  <span style="font-size: 12px; color: #606266; margin-left: 20px"
                    >注意：{{formIn.activityType == 3 ? '包邮量' :'起批量' }}必须是购买倍数的整数倍</span
                  >
                </div>
           
              </div>

              <div  v-if="formIn.activityType == 3  ">
                <div class="row" >
                  <div class="tip"><span class="weight">*</span>采购总上限</div>
                  <div class="value input">
                    <el-input
                      size="small"
                      placeholder="请输入"
                      v-model="formIn.maxGroupTotalCount"
                    />
                  </div>
                </div> 
              </div>

              <div class="row"  v-if=" formIn.activityType == 3  ">
                <div class="tip"><span class="weight">*</span>单店采购上限</div>
                <div class="value input">
                  <el-input
                    size="small"
                    placeholder="请输入"
                    v-model="formIn.userMaxTotalBuyCount"
                  />
                </div>
              </div> 

              <div class="row"  v-if="formIn.activityType == 2 ">
                <div class="tip"><span class="weight">*</span>单店采购上限</div>
                <div class="value input">
                  <el-input size="small" placeholder="请输入" v-model="formIn.purchaseUpperLimit"
                     maxlength="8" 
                   />
                </div>
                <div class="value fill">
                  <el-checkbox v-model="formIn.showUpperLimit" >不限</el-checkbox>
                </div>
              </div>

                 <!-- 上限刷新周期 -->
              <div class="row"  v-if="formIn.activityType == 2  ">
                <div class="tip">上限刷新周期</div>
                <div class="value input">
                  <el-select v-model="formIn.upperLimitRefreshCycle" placeholder="请选择" size="small">
                    <el-option v-for="item in upperLimitRefreshCycle" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="row"  v-if="formIn.activityType == 2  ">
                <div class="tip">上限启用时间</div>
                <div class="value input">
                  <el-date-picker v-model="formIn.upperLimitStartTime"  
                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择"
                  size="small">
                  </el-date-picker> 
                </div>
                <div class="value fill small-tip">
                  <span style="font-size:12px;color:#606266;">
                    上限启用时间根据周期而定：活动期内- 上架时间起生效；单笔 - 设置后立即生效；
                    每天 - 设置当天00:00起效；每周 - 设置当周周一00:00起效；每月 - 设置当月1日00:00起效
                  </span>
                </div>
              </div>

              <div class="row"  v-if="formIn.activityType == 2  ||  formIn.activityType == 4  ">
                <div class="tip"><span class="weight">*</span>活动开始时间</div>
                <div class="value input">
                  <el-date-picker v-model="formIn.activityStartTime" type="datetime" placeholder="请选择" size="small"
                   value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="value fill small-tip" v-if="formIn.activityType == 2 ">
                  <el-checkbox v-model="formIn.eventCountdownFlag" :true-label="1" :false-label="0">是否显示倒计时样式</el-checkbox>
                </div>
              </div>

              <div class="row"  v-if="formIn.activityType == 2  ||  formIn.activityType == 4">
                <div class="tip"><span class="weight">*</span>活动结束时间</div>
                <div class="value input">
                  <el-date-picker v-model="formIn.activityEndTime"  type="datetime" default-time="23:59:59"
                    placeholder="请选择" size="small" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="value fill small-tip">
                  <span style="font-size:12px;color:#606266;">
                    商品在活动开始时间到活动结束时间之间显示在app/PC。超过活动结束时间后不可编辑或延长时间
                  </span>
                </div>
              </div>

              <div class="row"  v-if="formIn.activityType == 2  ">
                <div class="tip"><span class="weight">*</span>能否特价凑单</div>
                <div class="radio-list">
                  <div class="list-a">
                    <el-radio v-model="formIn.uniqueFlag" :label="1">订单中只能有此品一个特价</el-radio>
                  </div>
                  <div class="list-a">
                    <span class="tips">一笔订单中只能有此商品一个特价商品，其他特价商品不能一同下单</span>
                  </div>
                  <div class="list-a">
                    <el-radio v-model="formIn.uniqueFlag" :label="0">能与其他特价商品凑单</el-radio>
                  </div>
                  <div class="list-a">
                    <span class="tips">一笔订单中添加此特价商品后，还能添加其他特价商品凑单</span>
                  </div>
                </div>
              </div>

              <div class="row" v-if="goodsId == xiaocaihuId ">
                <div class="tip">  收取赠品金</div> 
                <div class="value fill">
                    <el-checkbox v-model="formIn.chargeFlag"  :true-label="1" :false-label="0" > </el-checkbox>
                    <span style="color: #f5222d; font-size: 12px;">
                        赠品收取金额时，订单只能整单退货，退货时将赠品金额一并退回
                    </span> 
                </div>
            </div> 

            </div>
          </div>
          <div class="big-block">
            <div class="title-block">
              <span class="text">图片/其他</span>
            </div>
            <div class="form-content">
              <div class="row">
                <div class="tip"><span class="weight">*</span>商品标题</div>
                <div class="value input">
                  <el-input
                    size="small"
                    placeholder="请输入"
                    v-model="formIn.goodsSkuTitle"
                  />
                </div>
              </div>
              <div class="row">
                <div class="tip">产品批号</div>
                <div class="value input">
                  <el-input
                    size="small"
                    placeholder="请输入"
                    v-model="formIn.batchNumber"
                  />
                </div>
              </div>
              <div class="row mutlti">
                <div class="tip">商品图片</div>
                <div class="value mutlti v">
                  <div class="in-row">
                    <el-radio v-model="formIn.imgRegion" :label="1"
                      >使用平台图片</el-radio
                    >
                    <el-radio v-model="formIn.imgRegion" :label="2">上传图片</el-radio>
                  </div>
                  <template v-if="formIn.imgRegion === 2">
                    <div class="in-row">
                      <div class="pic-layout">
                        <div
                          class="item"
                          v-for="(item, index) in imageUrlList ? imageUrlList : []"
                          :key="index"
                        >
                          <el-image
                            :ref="`myImg${index}`"
                            :src="item"
                            fit="cover"
                            class="icon"
                            :initial-index="index"
                            :preview-src-list="imageUrlList"
                          />
                          <div class="preview">
                            <el-image
                              :src="SeeIcon"
                              class="btn-icon"
                              @click="handlePreview(`myImg${index}`)"
                            />
                            <el-image
                              :src="DelIcon"
                              class="btn-icon"
                              @click="handleDeleteImage(index)"
                            />
                          </div>
                        </div>
                        <div class="item add-pic" @click="handleUpload()">
                          <div class="image-wrap">
                            <el-image :src="AddIcon" />
                          </div>
                          <span class="text">上传图片</span>
                        </div>
                      </div>
                    </div>
                    <div class="in-row">
                      <span class="value small-tip"
                        >注意：上传图片需要审核，最多五张，图片尺寸建议1080*1080px</span
                      >
                    </div>
                  </template>
                </div>
              </div>
              <div class="row mutlti big">
                <div class="tip">商品标签</div>
                <div class="value fill">
                  <div class="flag-block">
                    <!-- <span class="flag-title">商品标签</span> -->
                    <el-radio
                      v-model="formIn.shopLabelId"
                      :label="item.id"
                      :key="item.id"
                      v-for="item in shopLabelList ? shopLabelList : []"
                    >
                      {{ item.labelName }}
                    </el-radio>
                  </div>
                </div>
              </div>
              <div class="row contine">
                <div class="tip"></div>
                <div class="value fill small-tip">
                  <span>
                    标签是显示在app商品列表图上的边框/角标优惠信息。
                    商家标签可在商品管理-商家标签上传
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="tip">商家店铺页排序</div>
                <div class="value input">
                  <el-input
                    placeholder="请输入"
                    v-model="formIn.sortCode"
                    maxlength="5"
                  />
                </div>
                <div class="value small-tip">
                  <span>注意：排序大的靠前，最大99999</span>
                </div>
              </div>
              <div class="row mutlti">
                <div class="tip">批件药检报告等</div>
                <div class="value input fill">
                  <!-- <el-upload class="upload-demo" :action="action" :on-preview="handlePreviewUpload"
                    :on-remove="handleRemove" :before-remove="beforeRemove" multiple :file-list="fileList"
                    :on-success="onSuccessUpload" accept=".jpg,.jpeg,.png,.pdf">
                    <div class="sigle-row-up-btns">
                      <el-button size="small">点击上传</el-button>
                      <div class="el-upload__tip">上传pdf或图片，且不超过10M</div>
                    </div>
                  </el-upload> -->
                  <fileUpload
                    v-model="fileList"
                    @onRemoveHandler="onRemoveHandler"
                  ></fileUpload>
                  <!-- <span>上传pdf或图片，且不超过10M</span> -->
                </div>
              </div>

              <div class="row" v-if="formIn.activityType == 2  ">
                <div class="tip">商品活动说明</div>
                <wangEnduit :value="formIn.activityDescription" :is-clear="false" :isDisabled="isDisabled"
                   style="margin-left: 20px;" />
              </div>
              
            </div>
          </div>
        </div>
        <div class="harf-block">
          <div class="big-block">
            <div class="title-block">
              <span class="text">销售规则</span>
            </div>
            <div class="form-content">
              <div class="row">
                <div class="tip"><span class="weight">*</span>配置方式</div>
                <div class="value fill">
                  <el-radio v-model="formIn.type" :label="0">
                    设置区域、客户类型及黑名单
                  </el-radio>
                  <el-radio v-model="formIn.type" :label="1">白名单</el-radio>
                </div>
              </div>
              <template v-if="formIn.type === 0">
                <div class="row mutlti big">
                  <div class="tip">地域</div>
                  <div class="value fill">
                    <div class="flag-block">
                      <el-radio
                        v-model="formIn.areaId"
                        :label="item.areaId"
                        :key="item.areaId"
                        v-for="item in areaIdList ? areaIdList : []"
                      >
                        {{ item.schemeName }}
                      </el-radio>
                    </div>
                  </div>
                </div>
                <div class="row contine">
                  <div class="tip"></div>
                  <div class="value fill small-tip">
                    <span> 注意：仅限已选地域对应客户可购买当前商品。 </span>
                  </div>
                  <div class="value">
                    <el-button size="small" icon="el-icon-plus" @click="handleAddArea"
                      >新增地域</el-button
                    >
                  </div>
                </div>
                <div class="row mutlti big">
                  <div class="tip">客户类型</div>
                  <div class="value fill">
                    <div class="flag-block">
                      <el-checkbox
                        style="margin-right: 30px"
                        v-model="checkAll"
                        :indeterminate="isIndeterminate"
                        @change="handleCheckAllChange"
                        >全选</el-checkbox
                      >
                      <el-checkbox-group
                        v-model="formIn.shopTypeCode"
                        @change="changeCheckList"
                      >
                        <el-checkbox
                          :label="item.typeCode"
                          :key="item.typeCode"
                          v-for="item in listData ? listData : []"
                          >{{ item.typeName }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                  </div>
                </div>
                <div class="row contine">
                  <div class="tip"></div>
                  <div class="value fill small-tip">
                    <span> 注意：被勾选的客户类型对应的客户可购买当前商品。 </span>
                  </div>
                </div>
              </template>
              <div class="row mutlti big">
                <div class="tip">
                  {{ formIn.type == "1" ? "白名单" : "黑名单" }}
                </div>
                <div class="value fill">
                  <div class="flag-block">
                    <el-radio
                      v-model="formIn.groupId"
                      :label="item.id"
                      :key="item.id"
                      v-for="item in userList ? userList : []"
                    >
                      {{ item.schemeName }}
                    </el-radio>
                  </div>
                </div>
              </div>

              <div class="row mutlti big" v-if="formIn.type == 1">
                <div class="tip">指定客户(九和)</div>
                <div class="value fill">
                  <div class="flag-block">
                    <el-radio
                      v-model="formIn.groupId"
                      :label="item.id"
                      :key="item.id"
                      v-for="item in userList2 ? userList2 : []"
                    >
                      {{ item.schemeName }}
                    </el-radio>
                  </div>
                </div>
              </div>

              <div class="row contine">
                <div class="tip"></div>
                <div class="value fill small-tip">
                  <span> 注意：黑名单客户不可购买当前商品。 </span>
                </div>
                <div class="value">
                  <el-button size="small" icon="el-icon-plus" @click="handleAddUserGroup">
                    新增用户组
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="gloabl-btn"
             @click="handleLookOtherSku(formIn)">查看其他sku</div> -->
      </div>
    </el-form>

    <div class="bottom">
      <el-button @click="handleBack">返回上一页</el-button>
      <el-button type="primary" @click="doSubmit" v-if="fromPage == 'edit'"
        >修改保存商品</el-button
      >
    </div>

    <!-- <UploadImageView ref="imgupload"
                     request-id="1"
                     :imgType="imgType"
                     @upload="uploadSubmit" /> -->
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
// import UploadImageView from "@/views/myQualification/components/UploadImage.vue";

const IConst_Small = require("@/assets/public/icon-small.png");
const IConst_See_Icon = require("@/assets/zz/see-icon.png");
const IConst_Del_Icon = require("@/assets/zz/del-icon.png");
const IConst_Add_Icon = require("@/assets/zz/add-icon.png");

import { getunitList, getEnableListByType } from "@/api/productManage/auditProduct";

// 查询商品基础库详情
import { getCompGoodsBaseDetail } from "@/api/goodsManage/baseDepot";
// getCompGoodsBaseDetail
import {
  skuUpdate,
  skuAdd,
  skuId,
  groupInfos,
  salesgroupinfo,
  getErpStock,
  getErpPrice,
  getErpDate,
  skuUpdateExemption,
} from "@/api/salesControl/commodity";
import { getLabelInfoList } from "@/api/goods";
import dayjs from "dayjs";
import _ from "lodash";
import fileUpload from "@/components/fileUpload";
import wangEnduit from "@/components/wangEnduit";

let g_save = false;

export default {
  components: { ElImageViewer, fileUpload,wangEnduit },
  data() {
    return {
      xiaocaihuId:'1734837933549641729', // 小柴胡goodsId
      goodsId:'',
      smallIcon: IConst_Small,

      SeeIcon: IConst_See_Icon,
      DelIcon: IConst_Del_Icon,
      AddIcon: IConst_Add_Icon,

      action: process.env.VUE_APP_BASE_API + "/product/goodsbase/upload",

      imgType: "",
      IConst_Max_Pic_Count: 5,
      imageUrlList: [],
      limit: 1,

      fileList: [], //批件/药检报告等

      shopLabelList: [], //可选商品标签

      unitList: [], //可选单位

      areaIdList: [
        {
          areaId: "0000028",
          schemeName: "不限",
        },
      ], //地域列表

      listData: [], // 客户类型类别

      userList: [], //用户组列表
      userList2: [], //九和用户组列表

      isIndeterminate: false, //全选，不确定效果,选择了部分
      checkAll: true, //全选客户类型

      formIn: {
        multiple: "",
        beSynDate: false, //同步有效期和生产日期
        medicineCode: "", //ERP编码
        salePrice: "", //价格
        beSynPrice: false, //自动同步价格
        marketPrice: "", //市场价
        purchasePrice: "", //建议零售价
        goodsSkuInventory: "", //总库存
        beSynStock: false, //自动同步库存
        goodsSkuUnit: "", //单位
        startWholesale: "", //起批量
        useTimes: false, //配数购买
        expireTime: "", //有效期至
        producedTime: "", //生产日期
        goodsSkuTitle: "", //商品标题
        batchNumber: "", //产品批号
        imgRegion: 1, //1 使用平台图片 2 上传图片
        shopLabelId: "", //商品标签  数据来源待确认
        sortCode: "1", //店铺页排序
        type: 0, //配置方式 0 设置区域、客户类型及黑名单  1 白名单
        areaId: "0000028", //地域组id
        shopTypeCode: [], //客户类型：1.诊所,2.春播运营平台,3.医药公司
        groupId: "", //用户组
        maxGroupTotalCount: "", //	拼团总量上限
        groupBuyPrice: "", //价格
        userMaxTotalBuyCount: "", //	单用户累计购买上限		false
        maxGroupTotalCount: "", //	拼团总量上限
        uniqueFlag: 1, //能否特价凑单 0 能 1 不能
          showInventoryFlag: 0, //是否展示给客户剩余库存量 0 不展示 1 展示
          chargeFlag:0,  //0是不收费，1是收费
          showUpperLimit: false, // 是否显示上限

      },
      goodsDetail: { compGoodsBaseVo: {} },
      fromPage: "", //页面类型
      isDisabled: false, //是否禁止输入
      upperLimitRefreshCycle: [
        {
          label: '活动期内',
          value: 1
        },
        {
          label: '单笔',
          value: 2
        },
        {
          label: '每天 (每天00:00~24:00)',
          value: 5
        },
        {
          label: '每周 (周一00:00~周日24:00)',
          value: 3
        },
        {
          label: '每月 (每月1号00:00~每月最后一天24:00)',
          value: 4
        }
      ],
    };
  },
  computed: {
    // goodsDetail() {
    //   return this.$store.state.publicGoods.publicConfig.goodsDetail;
    // },
    // selectType () {
    //   return this.$store.state.publicGoods.publicConfig.selectType;
    // },
  },
  filters: {
    selectTypeDetail(e) {
      if (e == "1") return "一口价";
      if (e == "2") return "特价";
      if (e == "3") return "单品包邮";
      if (e == "4") return "赠品";
    },
  },
  created() {
    // this.initViews();
    this.doLoadLabelInfoList();
    this.getunitList();
    this.groupInfos();
    this.getEnableListByType();
    this.getDetail();
    this.getGoodsBaseDetail();
  
  },
  beforeDestroy() {
    // if (g_save) {
    //   const fill = _.cloneDeep(this.$data);
    //   this.$store.dispatch("publicGoods/setFillInfo", fill);
    //   g_save = false;
    // }
  },
  mounted() {
   
  },
  methods: {
    changePurchaseUpperLimitInput () {
      if (this.formIn.purchaseUpperLimit) {
        this.formIn.showUpperLimit = false;
      } else {
        this.formIn.showUpperLimit = true;
      }
    },
    // getErpDate
    dateChangeSyn() {
      let params = {};
      params.medicineCode = this.formIn.medicineCode;
      if (!this.formIn.beSynDate) {
        this.formIn.producedTime = "";
        this.formIn.expireTime = "";
        return;
      }
      getErpDate(params)
        .then((res) => {
          // console.log(res)
          if (res.producedTime) {
            this.formIn.producedTime = res.producedTime;
          }
          if (res.expireTime) {
            this.formIn.expireTime = res.expireTime;
          }
          if (!res.expireTime && !res.producedTime) {
            this.formIn.beSynDate = false;
            this.$message.warning("ERP未推送有效期和生产日期，请您手动设置!");
          } else {
            this.formIn.beSynDate = true;
          }
        })
        .catch((err) => {});
    },
    getDetail() {
      if (this.$route.query.fromPage == "detail") {
        this.isDisabled = true;
      }
      if(this.$route.query.goodsId) {
          this.goodsId = this.$route.query.goodsId;
      }
      if (
        this.$route.query.fromPage == "detail" ||
        this.$route.query.fromPage == "edit"
      ) {
        this.fromPage = this.$route.query.fromPage;
        // 查询详情
        let params = {};
        params.skuId = this.$route.query.skuId;
        this.formIn.skuId = this.$route.query.skuId;
        skuId(params.skuId).then((res) => {
          console.log(res, "---res");
          this.formIn = Object.assign(this.formIn, res);
          console.log(this.formIn, "---this.formIn");
          this.formIn.imgRegion = res.goodsSkuImageList ? 2 : 1;
          if (res.goodsSkuImageList) {
            this.imageUrlList = res.goodsSkuImageList.split(",");
          }
          if (res.goodsSkuFileList) {
            this.fileList = JSON.parse(res.goodsSkuFileList);
          }
          console.log(this.imageUrlList);
          if (this.formIn.type != undefined && this.formIn.type != null) {
            this.formIn.type = parseInt(this.formIn.type);
          }
          if (res.shopTypeCode) {
            this.formIn.shopTypeCode = res.shopTypeCode.split(",");
          } else {
            this.formIn.shopTypeCode = [];
            this.checkAll = false;
          }
          this.salesgroupinfo();
          this.changePurchaseUpperLimitInput(); 
        });
      }
    },
    // 删除上传的文件
    onRemoveHandler(file) {
      let index = this.fileList.indexOf(file);
      this.fileList.splice(index, 1);
    },
    getGoodsBaseDetail() {
      if (
        this.$route.query.fromPage == "detail" ||
        this.$route.query.fromPage == "edit"
      ) {
        // 查询详情
        let params = {};
        params.isMerchant = true;
        params.id = this.$route.query.goodsId;
        this.formIn.goodsId = this.$route.query.skuId;
        getCompGoodsBaseDetail(params).then((res) => {
          this.goodsDetail.compGoodsBaseVo = res.data.compGoodsBaseVo;
          // console.log(this.goodsDetail.compGoodsBaseV)
        });
      }
    },
    async erpPriceChange(e) {
      // erp同步价格状态发生变化
      if (e) {
        const resp = await getErpPrice({ medicineCode: this.formIn.medicineCode });
        if (resp) {
          this.formIn.salePrice = resp;
        } else {
          this.formIn.beSynPrice = false;
          this.$message.warning("ERP未推送商品价格数据或商品价格为0，请您手动设置价格");
          // this.formIn.salePrice = 0
        }
      }
    },
    async stockChange(e) {
      // erp同步库存状态发生变化
      if (e) {
        const resp = await getErpStock({ medicineCode: this.formIn.medicineCode });
        this.formIn.goodsSkuInventory = resp;
      } else {
        this.formIn.goodsSkuInventory = 0;
      }
    },
    initViews() {
      let publicConfig = this.$store.state.publicGoods.publicConfig;
      if (publicConfig) {
        if (publicConfig.fillProductInfoForm) {
          if (publicConfig.fillProductInfoForm.formIn) {
            let formInStore = publicConfig.fillProductInfoForm.formIn;
            for (let key in formInStore) {
              if (this.formIn.hasOwnProperty(key)) {
                this.formIn[key] = formInStore[key];
              }
            }
          }
        }

        this.$store.dispatch("publicGoods/setFillInfo", null);
      }
      if (this.goodsDetail) {
        const compGoodsBaseVo = this.goodsDetail.compGoodsBaseVo;
        this.formIn.goodsSkuTitle =
          `${compGoodsBaseVo.brand ? compGoodsBaseVo.brand + " " : ""}` +
          compGoodsBaseVo.name +
          " " +
          compGoodsBaseVo.specification;
      }
    },
    doSubmit() {
      //校验输入

      if (this.formIn.activityType == 3) {
        if (!this.formIn.groupBuyPrice || this.formIn.groupBuyPrice == 0.0) {
          this.$message.warning("请输入价格");
          return;
        }
        if (!this.formIn.userMaxTotalBuyCount) {
          this.$message.warning("请输入单店采购上限");
          return;
        }
        if (!this.formIn.maxGroupTotalCount) {
          this.$message.warning("请输入采购总上限");
          return;
        }
      } else {
        if (!this.formIn.salePrice || this.formIn.salePrice == 0.0) {
          this.$message.warning("请输入价格");
          return;
        }
      }
      if (!this.formIn.goodsSkuUnit) {
        this.$message.warning("请选择单位");
        return;
      }
      if (!this.formIn.startWholesale) {
        this.$message.warning("请输入起批量");
        return;
      }
      if (!this.formIn.expireTime) {
        this.$message.warning("请选择有效期至");
        return;
      }
      if (!this.formIn.producedTime) {
        this.$message.warning("请选择生产日期");
        return;
      }
      if (
        new Date(this.formIn.producedTime).getTime() >
        new Date(this.formIn.expireTime).getTime()
      ) {
        this.$message.warning("生产日期大于有效期，请重新选择");
        return;
      }
      if (!this.formIn.goodsSkuTitle) {
        this.$message.warning("请输入商品标题");
        return;
      }

      let data = {
        goodsId: this.goodsDetail.compGoodsBaseVo.id,
        activityType: this.formIn.activityType,
      };
      //详情

      //输入框相关
      _.merge(data, this.formIn);

      data.expireTime = this.formIn.expireTime
        ? dayjs(this.formIn.expireTime).format("YYYY-MM-DD HH:mm:ss")
        : "";
      data.producedTime = this.formIn.producedTime
        ? dayjs(this.formIn.producedTime).format("YYYY-MM-DD HH:mm:ss")
        : "";
      //做某些字段的特殊处理
      data.goodsSkuFileList =
        this.fileList.length > 0 ? JSON.stringify(this.fileList) : "";

      data.shopTypeCode = "";
      if (
        this.formIn.shopTypeCode instanceof Array &&
        this.formIn.shopTypeCode.length > 0
      ) {
        data.shopTypeCode = this.formIn.shopTypeCode.join(",");
      }

      if (
        this.formIn.imgRegion == 2 &&
        this.imageUrlList instanceof Array &&
        this.imageUrlList.length > 0
      ) {
        data.goodsSkuImage = this.imageUrlList[0];
        data.goodsSkuImageList = this.imageUrlList.join(",");
      }

      if (this.imageUrlList.length == 0) {
        data.goodsSkuImageList = "";
        data.goodsSkuImage = "";
      }

      // 使用平台时，清空商品图片
      if (this.formIn.imgRegion == 1) {
        data.goodsSkuImage = "";
        data.goodsSkuImageList = "";
      }
      if (this.fromPage == "edit") {
        data.id = this.formIn.skuId;
        data.goodsId = this.formIn.goodsId;
      }
      if (this.formIn.activityType == 3) {
        data.userMaxTotalBuyCount = this.formIn.userMaxTotalBuyCount;
        data.maxGroupTotalCount = this.formIn.maxGroupTotalCount;
        data.groupBuyPrice = this.formIn.groupBuyPrice;
        data.minSingleBuyCount = this.formIn.startWholesale;
        data.multiple = this.formIn.multiple;

        skuUpdateExemption(data).then((res) => {
          if (res) {
            this.$message.success("提交成功");
            this.handleBack();
          }
        });
      } else {
        skuUpdate(data).then((res) => {
          if (res) {
            this.$message.success("提交成功");
            this.handleBack();
          }
        });
      }
    },
    changeCheckList(value) {
      console.log(value, "-value");
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.listData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.listData.length;
    },
    handleCheckAllChange(val) {
      console.log(val, "-val");
      this.formIn.shopTypeCode = [];
      if (val && this.listData instanceof Array) {
        this.listData.forEach((item) => {
          this.formIn.shopTypeCode.push(item.typeCode);
        });
      }
      this.isIndeterminate = false;
      console.log(this.formIn.shopTypeCode, "-- this.formIn.shopTypeCode");
    },
    doLoadLabelInfoList() {
      const skuId = this.$route.query.skuId;
      const obj = { 
        type: 2,
        skuId: skuId
      }
      getLabelInfoList(obj).then((data) => {
        console.log(data,'data')
        if (data instanceof Array && data.length > 0) {
          this.shopLabelList = data;
          console.log(this.shopLabelList,'--this.shopLabelList')
        }
      });
    },
    // 获取单位字典
    getunitList() {
      getunitList().then((res) => {
        if (res.code == 0) {
          this.unitList = res.data || [];
        }
      });
    },
    // 查询地域组信息
    groupInfos() {
      const skuId = this.$route.query.skuId;
      groupInfos(skuId).then((res) => {
        this.areaIdList = this.areaIdList.concat(res);
      });
    },
    // 查询用户组信息
    salesgroupinfo() {
      let params = {};
      params.type = 1;
      console.log(this.formIn.deptId, "--this.formIn.deptId");
      if (this.formIn.deptId) {
        params.deptId = this.formIn.deptId;
      }
      salesgroupinfo(params).then((res) => {
        this.userList = res;
        if (params.type == 1) {
          this.salesgroupinfo2();
        }
      });
    },
    salesgroupinfo2() {
      let params = {};
      params.type = 2;
      if (this.formIn.deptId) {
        params.deptId = this.formIn.deptId;
      }
      salesgroupinfo(params).then((res) => {
        this.userList2 = res;
      });
    },
    // 获取类型
    getEnableListByType() {
      let params = {
        type: 0,
      };
      getEnableListByType(params).then((res) => {
        console.log(res, "getEnableListByType");
        if (res.code == 0) {
          this.listData = res.data;

          if (this.listData && this.listData.length > 0 && this.checkAll) {
            this.formIn.shopTypeCode = [];
            this.listData.forEach((item) => {
              this.formIn.shopTypeCode.push(item.typeCode);
            });
          }
        }
      });
    },
    updateCheckAllView() {
      //
    },
    handleAddArea() {
      g_save = true;

      this.$router.push("/salesControlMange/salesControl-controlPinForm-areaTemplate");
    },
    handleAddUserGroup() {
      g_save = true;

      this.$router.push("/salesControlMange/salesControl-controlPinForm-userTemplate");
    },
    handleLookOtherSku(row) {
      g_save = true;

      this.$router.push({
        path: "/productManage/salesControl-publish-addGoodsToStore",
        query: {
          activeName: "add",
          id: row.goodsId,
          type: "add",
        },
      });
    },
    handleUpload(bigIndex) {
      //this.currentBigIndex = bigIndex;
      this.$refs["imgupload"].open(this.imgType);
    },
    uploadSubmit(obj) {
      const { type, url } = obj;
      this.imageUrlList.push(url);
    },
    handlePreview(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName][0].showViewer = true;
      }
    },
    handleDeleteImage(samllIndex) {
      this.imageUrlList.splice(samllIndex, 1);
      console.log(this.imageUrlList, "this.imageUrlList");
    },
    handleBack() {
      // this.$emit("preStep");
      this.$router.back(-1);
      // this.$router.replace({
      //   path: "/productManage/salesControl-commodity-list",
      // });
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handlePreviewUpload(file) {
      console.log(file);
      if (
        file.url.indexOf("http") > -1 ||
        file.url.indexOf(".PDF") > -1 ||
        file.url.indexOf(".png") > -1 ||
        file.url.indexOf(".jpg") > -1 ||
        file.url.indexOf(".jpeg") > -1
      ) {
        window.open(file.url);
      } else {
        this.url = file.url;
        this.showViewer = true;
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    onSuccessUpload(res, file, fileList) {
      this.fileLength++;
      // 这里需要根据你自己的接口返回数据格式和层级来自行修改
      if (res.data) {
        // 判断接口上传成功
        if (this.fileList.length < this.limit) {
          // 未超限时，把接口返回的图片url地址添加到fileList
          let datas = res.data;
          datas.name = res.data.fileName;
          this.fileList.push(datas);
        }
      } else {
        // 判断接口上传失败
        this.syncElUpload();
        this.$refs.uploadRef.clearFiles();
        this.$message({ type: "error", message: res.msg });
      }
      if (this.fileLength === fileList.length) {
        this.isUploading = false;
      }
    },
    success(res) {
      console.log(res);
    },
  },
};
</script>

<style lang="scss" scoped>
.fill-product-info-root {
  height: 100%;
  background: #fff;
  padding: 24px;
  overflow: auto;
  .sold-out {
    margin-top: 20px;
    &-title {
      font-size: 16px;
      font-weight: 600;
    }
    &-content {
      width: 548px;
      font-size: 14px;
      font-weight: 400;
      color: #262626;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      padding: 20px;
      margin-top: 20px;
    }
  }
  .product-info {
    width: 548px;
    height: 146px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    margin-top: 24px;
    padding: 24px;
    box-sizing: border-box;
    position: relative;

    .pic-frame {
      width: 98px;
      height: 98px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      .pic {
        width: 72px;
        height: 86px;
      }
    }

    .txt-content {
      flex: 1;
      margin-left: 30px;

      .big-title {
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        line-height: 32px;
      }

      .desp {
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: #595959;
        line-height: 22px;
      }
    }

    .flag {
      position: absolute;
      top: 0;
      right: 0;
      width: 72px;
      height: 28px;
      background: #ffb536;
      border-radius: 0px 4px 0px 8px;
      font-size: 16px;
      font-weight: 500;
      text-align: left;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .big-content {
    display: flex;
    flex-direction: row;
    margin-top: 16px;
    position: relative;

    .gloabl-btn {
      position: absolute;
      right: 0;
      bottom: 36px;
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
      cursor: pointer;
    }

    .harf-block {
      flex: 1;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;

      &:first-child {
        border-right: 1px solid #f2f2f2;
        margin-right: 16px;
        padding-right: 16px;
        box-sizing: border-box;
      }

      .big-block {
        &:not(:first-child) {
          margin-top: 12px;
        }
      }

      .title-block {
        height: 40px;
        display: flex;
        align-items: center;
        position: relative;
        padding-left: 12px;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          width: 3px;
          height: 16px;
          background: #f5222d;
          border-radius: 2px;
          transform: translateY(-50%);
        }

        .text {
          font-size: 16px;
          font-weight: 600;
          text-align: left;
          color: #f6212d;
        }
      }

      .form-content {
        .row {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 8px 0;
          box-sizing: border-box;

          &.mutlti {
            align-items: flex-start;
          }

          &.contine {
            padding-top: 0;
          }

          &.big {
            .tip {
              padding-top: 16px;
            }
          }

          .tip {
            width: 8em;
            text-align: right;
            font-size: 14px;
            font-weight: 400;
            text-align: right;
            color: #262626;

            .weight {
              color: #f5222d;
            }
          }

          .value {
            margin-left: 16px;

            &.input {
              width: 204px;

              ::v-deep .el-date-editor.el-input,
              ::v-deep .el-date-editor.el-input__inner {
                width: 100%;
              }
            }

            &.fill {
              flex: 1;
              width: 0;
            }

            &.small-tip {
              flex: 1;
              width: 0;
              font-size: 14px;
              font-weight: 400;
              text-align: left;
              color: #8c8c8c;
            }

            &.mutlti {
              flex: 1;
              width: 0;
              display: flex;

              &.v {
                flex-direction: column;

                .in-row {
                  &:not(:first-child) {
                    margin-top: 8px;
                  }
                }
              }
            }

            .flag-block {
              width: 100%;
              background: #fafafa;
              border: 1px solid #d9d9d9;
              border-radius: 4px;
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              padding: 8px 16px 16px 16px;
              box-sizing: border-box;
              flex-wrap: wrap;

              .flag-title {
                font-size: 14px;
                font-weight: 400;
                color: #262626;
                margin-right: 8px;
              }

              & > * {
                margin-top: 8px;
              }
            }
          }

          .in-row {
            .value {
              margin-left: 0;
            }
          }
        }
      }
    }
  }

  .bottom {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    border-top: 1px solid #f2f2f2;
  }

  .pic-layout {
    display: flex;

    .item {
      width: 86px;
      height: 86px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      position: relative;
      overflow: hidden;

      & + .item {
        margin-left: 8px;
      }

      .icon {
        position: relative;
        width: 100%;
        height: 100%;
      }

      .preview {
        position: absolute;
        visibility: hidden;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0.5;
        background: #000000;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-icon {
          width: 16px;
          height: 16px;
          cursor: pointer;

          & + .btn-icon {
            margin-left: 8px;
          }
        }
      }

      &:hover {
        .preview {
          visibility: visible;
        }
      }

      &.add-pic {
        border: 1px dashed #d9d9d9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .image-wrap {
          border: 1px dashed #d9d9d9;
          width: 20px;
          height: 20px;

          & > * {
            width: 100%;
            height: 100%;
          }
        }

        .text {
          font-size: 14px;
          font-weight: 400;
          color: #595959;
          margin-top: 8px;
        }
      }
    }
  }

  .sigle-row-up-btns {
    display: flex;

    .el-upload__tip {
      margin-left: 8px;
    }
  }
}

.tips {
  font-size: 12px;
  color: #606266;
  margin-left: 20px;
}

.radio-list {
  width: calc(100% - 180px);
  margin-left: 20px;

  .list-a {
    width: 100%;
    line-height: 30px;
  }

  .tips {
    font-size: 12px;
    color: #606266;
  }
}
</style>
